// removed by extract-text-webpack-plugin
module.exports = {"blockHeading":"_1IesSxHvhZ3n2GXkt-PdCN","filters":"bTHdG8hdUg85LbWAZmwE8","filter":"_1-OHIDtjTsWw0jbEp0pTwF","list-outer":"_2zm4xU7FJFm2Tz-qIXqUtO","list":"_1T63UL7bfxlZsaUVPWed3t","searching":"_1y_j1ia6C1YOMcv-oInjGq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DocumentFilterListBlock/DocumentFilterListBlock.module.scss
// module id = 751
// module chunks = 0